<template>
  <div
    v-if="versions && versions.length > 1"
    class="sku-version"
    ref="scrollBox"
    :class="{
      'sku-version--average': versions.length <= 3,
      'sku-version--pad': versions.length <= 5,
      'sku-version--atmosphere': hasAtmosphere,
      'sku-version--biggiftbox': isBigpromotion,
      'sku-version--customatmosphere': hasCustomAtmosphereBg,
      ['sku-version--' + discountType]: hasAtmosphere
    }"
  >
    <div
      class="version_item"
      v-for="(item, index) in versions"
      :key="index"
      @click="selectVersion(index, item.name)"
      :class="{
        [`version-item-${index}`]: true,
        'version_item--active': index == checkedSpecItemId - 1
      }"
      tabindex="0"
      :aria-label="`${index == checkedSpecItemId - 1 ? '已选中' : '未选中'},${formatSpecName(item.name)}`"
    >
      <span>{{ item.name | formatSpecName }}</span>
    </div>
  </div>
</template>

<script>
import skuEventBus from '../sku-select/eventBus'
import { mapGetters } from 'vuex'
export default {
  name: 'SkuVersion',
  filters: {
    // 如果有@符号，则取@符号后面的
    formatSpecName(str) {
      if (/@/.test(str)) {
        return str.split('@')[1]
      }
      return str
    }
  },
  props: {
    spuInfo: Object,
    skuInfo: Object,
    commonTrackData: Object
  },
  data() {
    return {
      checkedSpecItemId: 0 // 选中规格值的id
    }
  },
  computed: {
    ...mapGetters('detailv3', [
      // 颜色是否外显
      'showOuterColor',
      // 商品类型，1：手机 2：配件 3：服务 4：虚拟商品
      'goodsType',
      // 是否是有氛围抢购
      'isAtmosphere',
      // 活动类型
      // 优惠类型 vip,group,deposit,fullpay,quickbuy,bigpromotion,normal,quickbuypreheat
      // 分别对应 会员,拼团,定金,全款,抢购,大促,正常,抢购预热
      'discountType',
      'isNoAtmospherePromotion',
      'isBigpromotion',
      'hasCustomAtmosphereBg'
    ]),
    // 规格id数组
    specMain() {
      return this.spuInfo?.specItem?.specMain
    },
    // 第一规格项id
    specId() {
      let tempSpecId
      // 如果是手机，则一定有两个规格，第1个规格是版本
      if (this.goodsType == 1) {
        tempSpecId = this.specMain[0]
      } else if (this.goodsType == 2) {
        const specNum = this.specMain.length
        if (specNum == 1 && !this.showOuterColor) {
          // 如果只有一个规格，则一定为版本（因为这是版本组件）
          tempSpecId = this.specMain[0]
        } else if (specNum == 2) {
          Object.entries(this.spuInfo.specItem?.specMainSeq).forEach(item => {
            if (item[1] !== '颜色') {
              tempSpecId = item[0]
            }
          })
        }
      }

      return tempSpecId
    },
    specName() {
      return this.spuInfo.specItem?.specMainSeq[this.specId]
    },
    versions() {
      return this.spuInfo?.specItem?.specItemSeq?.[this.specId]
    },
    // 是否有氛围
    hasAtmosphere() {
      if (this.discountType == 'quickbuy') {
        return !!this.isAtmosphere || this.isNoAtmospherePromotion
      } else {
        return ['deposit', 'fullpay', 'vip', 'quickbuy'].includes(this.discountType)
      }
    },
    trackData() {
      return {
        page_name: this.commonTrackData.page_name,
        sku_id: this.commonTrackData.sku_id,
        version_content: 2
      }
    }
  },
  watch: {
    checkedSpecItemId: {
      immediate: true,
      handler(specItemId, oldSpecItemId) {
        if (oldSpecItemId != undefined) {
          if (!document.body.scrollTo) {
            // 兼容安卓5.0
            Element.prototype.scrollTo = function (x, y) {
              this.scrollLeft = x
              this.scrollTop = y
            }
          }
          // 选中项变化后自动定位
          setTimeout(() => {
            // document.querySelector(`.version-item-${specItemId - 1}`)?.scrollIntoView({
            //   behavior: 'smooth',
            //   block: 'nearest',
            //   inline: 'center'
            // })
            this.$nextTick(() => {
              let lastSpot = this.$refs.scrollBox.scrollLeft
              // 每次移动距离
              const nextSpace = 7
              let scrollItemTimer = setInterval(() => {
                let offsetWidth = document.querySelector(`.version-item-${specItemId - 1}`)?.offsetWidth
                let scrollLeft = document.querySelector(`.version-item-${specItemId - 1}`)?.offsetLeft
                const containWidth = this.$refs?.scrollBox?.offsetWidth
                // 最终要停留的点
                let resultSpot = scrollLeft + offsetWidth / 2 - containWidth / 2
                if (Math.abs(lastSpot - resultSpot) < nextSpace) {
                  clearInterval(scrollItemTimer)
                }
                if (resultSpot >= lastSpot) {
                  lastSpot = lastSpot + nextSpace
                } else {
                  lastSpot = lastSpot - nextSpace
                }
                this.$refs?.scrollBox?.scrollTo(lastSpot, 0)
              }, 15)
            })
          }, 0)
        }
      }
    }
  },
  created() {
    this.bindEvent()
    // 曝光埋点
    this.$track(
      Object.assign({}, this.trackData, {
        cfrom: '173|001|02|077',
        event_id: '173|001|02|077'
      })
    )
  },
  methods: {
    formatSpecName(str) {
      if (/@/.test(str)) {
        return str.split('@')[1]
      }
      return str
    },
    // 绑定通信事件
    bindEvent() {
      // 规格项选中变化
      skuEventBus.$on('checkedSpecChange', ({ specId, specItemId, specName, specItemName }) => {
        if (specId == this.specId) {
          this.checkedSpecItemId = specItemId
        }
      })
      // const { checked } = skuSelect.getInitData(this.specId)
      // if (checked) {
      //   this.checkedSpecItemId = checked.id
      // }
    },
    selectVersion(index, name) {
      // 如果已经选中，则不作操作
      if (this.checkedSpecItemId - 1 == index) return false
      // 通知sku组件选中该规格
      skuEventBus.$emit('selectSpecItem', {
        specId: this.specId,
        specItemId: index + 1,
        specName: this.specName,
        specItemName: name
      })
      // 点击埋点
      this.$track(
        Object.assign({}, this.trackData, {
          cfrom: '173|001|01|077',
          event_id: '173|001|01|077'
        })
      )
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
<style lang="scss" scoped>
.vivo-fontscale-4 {
  .version_item {
    padding: 0 27px;
  }
}
.vivo-fontscale-5 {
  .version_item {
    padding: 0 22px;
  }
}
</style>
